import { AuthService } from './../../../core/services/auth.service';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ValidationErrors } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { ContentsService } from 'src/app/core/services/contents.service';
import { LOCAL_STORAGE_CONSTANT } from 'src/app/core/services/local-storage.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { MyInterestService } from 'src/app/core/services/my-interest.service';
import { PlansService } from 'src/app/core/services/plans.service';
import { AudioNotPublishedComponent } from '../../all-modals/audio-not-published/audio-not-published.component';
import { AudioNotUploadedComponent } from '../../all-modals/audio-not-uploaded/audio-not-uploaded.component';
import { AudioPublishedComponent } from '../../all-modals/audio-published/audio-published.component';
import { AudioUploadedComponent } from '../../all-modals/audio-uploaded/audio-uploaded.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { PublicationNotPublishedComponent } from '../../all-modals/publication-not-published/publication-not-published.component';
import { PublicationNotUploadedComponent } from '../../all-modals/publication-not-uploaded/publication-not-uploaded.component';
import { PublicationPublishedComponent } from '../../all-modals/publication-published/publication-published.component';
import { PublicationUploadedComponent } from '../../all-modals/publication-uploaded/publication-uploaded.component';
import { VideoNotPublishedComponent } from '../../all-modals/video-not-published/video-not-published.component';
import { VideoNotUploadedComponent } from '../../all-modals/video-not-uploaded/video-not-uploaded.component';
import { VideoPublishedComponent } from '../../all-modals/video-published/video-published.component';
import { VideoUploadedComponent } from '../../all-modals/video-uploaded/video-uploaded.component';
import { AudioPreviewWrapperComponent } from '../../material-detail/audio-preview-wrapper/audio-preview-wrapper.component';
import { PublicationPreviewWrapperComponent } from '../../material-detail/publication-preview-wrapper/publication-preview-wrapper.component';
import { VideoPreviewWrapperComponent } from '../../material-detail/video-preview-wrapper/video-preview-wrapper.component';
import { UploadSpaceModalComponent } from './upload-space-modal/upload-space-modal.component';
import { ImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { UserConfirmedComponent } from '../../auth/user-confirmed/user-confirmed.component';
import { Router } from '@angular/router';
import { ContentTypeSelectorComponent } from '../content-type-selector/content-type-selector.component';

@Component({
  selector: 'app-upload-publication',
  templateUrl: './upload-publication.component.html',
  styleUrls: ['./upload-publication.component.scss']
})
export class UploadPublicationComponent implements OnInit, OnDestroy {

  @Input() public content;
  @Input() public paidPlan;
  @Input() public fromModule;
  @Input() public publication_text;
  @Input() public selectedTemplate;
  @Input() public for;

  minDate: any;
  dropdownList = [];
  materialTypeList = [];
  selectedItems: any = [];
  selectedMaterial = [];
  dropdownSettings: any = {
    singleSelection: false,
    selectAllText: 'Select All',
    // enableCheckAll: true,
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "myclass custom-class",
    noDataLabel: "No genre found",
    text: 'Select Genre',
    limitSelection: 5
  };
  dropdownMaterialSettings = {
    singleSelection: true,
    // enableFilterSelectAll: false,
    noDataLabel: "No material found",
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "myclass custom-class",
    text: 'Select material type'
  };
  uploadPublicationContent: FormGroup;
  uploadPublicationContentArray: FormArray;
  errorMessage: string;
  submitted: boolean = false;
  isError: boolean = false;
  fileList: any;
  formData: FormData;
  fileName: any = [];
  trailerName: any = [];
  contentTypeSubscription: any;
  contentType: any;
  imagePath: any = [];
  imgURL: any = [];
  isFileUploaded: any = [];
  isTrailerUploaded: any = [];
  isThumbnailUploaded: any = [];
  isImageError: any = [];
  isTrailerImageError: any = [];
  taggedInterestEdit = [];
  file: any = [];
  isThumbnailError: any = [];
  isSvgThumbnailError: any = [];
  taggedInterestCopy = [];
  thumbnail: any = [];
  audioBook: any = [];
  trailerFile: any = [];
  isAudioBookUploaded: any = [];
  isAudioBookError: any = [];
  audioFileName: any = [];
  audioFileLink: any = [];
  trailerFileLink: any = [];
  audioStepError: boolean = false;
  maxSizeExceded: boolean = false;
  thumbnailSizeError: any = [];
  fileLink: any = [];
  thumbnailLink: any;
  currentProgress = 0;
  uploadedBytes = 0;
  deSelectedArray = [];
  videoUploadType = [
    'mp4'
  ];
  audioUploadType = [
    'mp3'
  ];
  publicationUploadType = [
    // 'doc',
    // 'docx',
    'pdf',
    // 'odf'
  ];
  editFlag: boolean = false;
  showFileSizeEror: boolean = false;
  fileSizeError: any = [];
  showTrailerSizeEror: boolean = false;
  trailerSizeError: any = [];
  //showAgeGap: boolean = false;
  str: string = "There is not enough available storage to upload content."
  showProgress: boolean = false;
  progress = 0;
  textAreaLength = 0;
  activePlan: any;
  mode: string = "private";
  userData;
  filePreviewString: any = [];
  trailerPreviewString: any = [];
  audioBookPreviewString: any = [];
  step: any = [];
  firstStepSubmit: any = [];
  secondStepSubmit: any = [];
  finalStepSubmit: boolean = false;
  activePanelIds: string[] = [];
  currentUploadIndex: number = 0;
  isFormValid: boolean = true;
  addMorePriceFlag: any = [
    [
      {
        priceFlag: false
      }
    ]
  ];

  showAboveField: any = [];
  aboveValue: any = [];
  aboveTokenValue: any = [];
  bulkDiscountEnabled: any = [];

  imageErrorMsg: string = LITERALS.VALIDATION.IMAGE_VALIDATION_WITHOUT_GIF;

  aboveValueLimit: number = 300;
  content_price_ranges_limit: number = 5;
  bulkIsEnabled: boolean = false;

  @ViewChild('audioContent', { static: true }) audioBookImage: ElementRef;
  @ViewChild('file', { static: true }) thumbnailImage: ElementRef;
  @ViewChild('fileContent', { static: true }) contentImage: ElementRef;
  currentUser: any;

  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private _contentsService: ContentsService,
    private _myInterest: MyInterestService,
    public localStorage: LocalStorageService,
    private _spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _plansService: PlansService,
    private _localStorageService: LocalStorageService,
    private domSanitizer: DomSanitizer,
    private _authService: AuthService,
    private _router: Router
  ) {
    if (!document.body.classList.contains('upload-modal')) {
      document.body.classList.add("upload-modal");
    }
    this.uploadPublicationContent = this.formBuilder.group({
      uploadPublicationContentArray: new FormArray([])
    });

    this.contentFormArray.push(this.contentFormBuilder);

  }
  get contentFormBuilder() {
    return this.formBuilder.group({
      out_line: ['', Validators.compose([Validators.required, Validators.pattern('^(?=.*?[a-zA-Z]).+$')])],
      description: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.TEXT_AREA)])],
      tagged_interests_attributes: ['', Validators.required],
      material_id: ['', Validators.required],
      duration_number: [''],
      duration_number_bulk: [''],
      duration_units: [''],
      duration_units_bulk: [''],
      library_type: ['', Validators.required],
      adult_content: ['', Validators.required],
      is_deleted: [false, Validators.required],
      link: ['', Validators.required],
      thumbnail: ['', Validators.required],
      content_type: ['', Validators.required],
      is_downloadable: [false],
      tokens: [0],
      content_prices_attributes: this.formBuilder.array([]),
      no_of_clicks: ['']
    })
  }
  get f() { return this.uploadPublicationContent.controls; }
  get contentFormArray() { return this.f.uploadPublicationContentArray as FormArray; }

  priceFormArray(index) { return this.contentFormArray.at(index).get("content_prices_attributes") as FormArray; }

  ngOnInit() {
    // if (this.content && this.content.content_prices.length > 0) {
    //   let obj = this.formBuilder.group({
    //     min_qty: [1, Validators.required],
    //     // max_qty: [null, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
    //     max_qty: [''],
    //     tokens: [null, Validators.compose([Validators.required, Validators.min(1)])]
    //   });
    //   this.priceFormArray(0).push(obj);
    // }
    this.currentUser = this._authService.getCurrentUser();
    this.activePanelIds.push('panel1');
    this.step[0] = 1;

    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user;
    if (this.userData.user_account_type == 'supplementary') {
      this.str = "There is not enough available storage to upload content. Please contact your parent.";
      this.contentFormArray.controls[0].patchValue({
        adult_content: 'all'
      })
    }
    this.minDate = new Date();

    this.subscribeContentType(0);
    this._contentsService.getMaterialType().subscribe((response: any) => {
      if (this.contentType) {
        this.materialTypeList = response.data[this.contentType.toLowerCase()];
      }
      else {
        let keyName = ''
        switch (this.content.content_type) {
          case 'document': keyName = 'publications'; break;
          case 'audio': keyName = 'audios'; break;
          case 'video': keyName = 'videos'; break;
        }
        this.materialTypeList = response.data[keyName];
        this.contentType = keyName;
      }
      this.setGenres();
      if (this.materialTypeList && this.materialTypeList.length) {
        this.materialTypeList.map(val => {
          val.itemName = val.material_text;
        });
      }
    });

    if (this.content) {
      this.contentType = this.content.content_type;
      let keyName = ''
      switch (this.content.content_type) {
        case 'document': keyName = 'publications'; break;
        case 'audio': keyName = 'audios'; break;
        case 'video': keyName = 'videos'; break;
      }
      this.contentType = keyName;
      this.editFlag = true;
      this.isFileUploaded[0] = true;

      const taggedEle = this.contentFormArray.controls[0]['controls'].tagged_interests_attributes;
      taggedEle.clearValidators();
      taggedEle.updateValueAndValidity();
      this.contentFormArray.controls[0].patchValue({
        thumbnail: this.content.thumb,
      });

      this.contentFormArray.controls[0].patchValue({
        no_of_clicks: this.content.content_relationship.no_of_clicks != null ? this.content.content_relationship.no_of_clicks : 0,
      });

      if (this.content.thumb) {
        this.imgURL[0] = API_ENDPOINTS.BASE_URL + this.content.thumb;
      }
      if (this.content.material && this.content.material.material_text) {
        this.selectedMaterial.push([{
          id: this.content.material ? this.content.material.material_id : '',
          material_text: this.content.material ? this.content.material.material_text : '',
          itemName: this.content.material ? this.content.material.material_text : ''
        }]);
      }

      if (this.content.content_prices.length > 0) {
        this.bulkDiscountEnabled[0] = true;
        if (this.content.content_prices.length > 1) {
          this.showAboveField[0] = true;

          for (let index = 0; index < this.content.content_prices.length - 1; index++) {
            let obj = this.formBuilder.group({
              min_qty: [+this.content.content_prices[index].min_qty, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
              max_qty: [+this.content.content_prices[index].max_qty, Validators.compose([Validators.required, Validators.min(+this.content.content_prices[index].min_qty + 1), Validators.max(this.aboveValueLimit)])],
              tokens: [+this.content.content_prices[index].tokens, Validators.compose([Validators.required, Validators.min(1)])],
              id: [+this.content.content_prices[index].id]
            }, {
              validator: this.maxValueValidator('min_qty', 'max_qty')
            });
            this.priceFormArray(0).push(obj);
            this.priceFormArray(0).controls[index].disable();
            let addPriceRange =
            {
              priceFlag: true
            }
            this.addMorePriceFlag[0].push(addPriceRange);
          }

          let addPriceRange =
          {
            priceFlag: false
          }
          this.addMorePriceFlag[0].push(addPriceRange);

          this.aboveValue[0] = this.content.content_prices[this.content.content_prices.length - 1].min_qty;
          this.aboveTokenValue[0] = this.content.content_prices[this.content.content_prices.length - 1].tokens;

        }
        else {
          this.showAboveField[0] = false;

          for (let index = 0; index < this.content.content_prices.length; index++) {
            let obj = this.formBuilder.group({
              min_qty: [+this.content.content_prices[index].min_qty, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
              max_qty: [+this.content.content_prices[index].max_qty, Validators.compose([Validators.required, Validators.min(+this.content.content_prices[index].min_qty + 1), Validators.max(this.aboveValueLimit)])],
              tokens: [+this.content.content_prices[index].tokens, Validators.compose([Validators.required, Validators.min(1)])],
              id: [+this.content.content_prices[index].id]
            }, {
              validator: this.maxValueValidator('min_qty', 'max_qty')
            });
            this.priceFormArray(0).push(obj);

            let addPriceRange =
            {
              priceFlag: true
            }
            this.addMorePriceFlag[0].push(addPriceRange);
          }

          let addPriceRange =
          {
            priceFlag: false
          }
          this.addMorePriceFlag[0].push(addPriceRange);

        }

        if (this.content.content_prices.length > 1)
          this.priceFormArray(0).controls[this.content.content_prices.length - 2].enable();
      }
      this.contentFormArray.controls[0].patchValue({
        ...this.content,
        library_type: this.content.content_relationship.library_type,
        adult_content: this.content.adult_content ? 'adult' : 'all'
      })

      if (this.content.tokens > 0) {
        this.paidPlan = true
      }
      this.getActivePlan();
      this.durationUnitChange(0);
    }
    else {
      this.getActivePlan();
    }
    // if (this.paidPlan) {
    //   this.updateTimeMatrixValidation(0);
    // }

  }

  setGenres() {
    let type = '';
    if (this.contentType.toLowerCase() == 'publications')
      type = "?content_type=document";
    else
      type = "?content_type=" + this.contentType.toLowerCase().slice(0, -1);
    this._myInterest.getMyInterest(type).subscribe((response: any) => {
      let dropdownList = response.data.interests;
      dropdownList.forEach(element => {

        if (this.contentType.toLowerCase() == 'publications' && element.content_type == 'document')
          this.dropdownList.push(element);

        else if (this.contentType.toLowerCase() == 'videos' && element.content_type == 'video')
          this.dropdownList.push(element);

        else if (this.contentType.toLowerCase() == 'audios' && element.content_type == 'audio')
          this.dropdownList.push(element);
      });

      if (this.content) {
        this.selectedItems[0] = [];
        this.dropdownList.forEach((element) => {
          this.content.tagged_interests.forEach((elementInterest) => {
            if (element.id === elementInterest.interest_id) {
              element['autoGeneratedId'] = elementInterest.id;
              this.selectedItems[0].push(element);
            }
          });
        });

        this.taggedInterestCopy = this.selectedItems;
        this.contentFormArray.controls[0]['controls'].tagged_interests_attributes.setValue(this.selectedItems[0]);
        if (this.dropdownList.length == this.selectedItems[0].length) {
          this.onSelectAll(this.selectedItems[0], 0)
        }
      }

      if (this.dropdownList && this.dropdownList.length) {
        this.dropdownList.map(val => {
          val.itemName = val.title;
        });
      }
    });
  }

  gotoNext(index) {
    if (this.step[index] == 1) {
      this.firstStepSubmit[index] = true;

      if (this.editFlag)
        this.onUpdate();

      if (this.imgURL[index] == '' || this.imgURL[index] == undefined
        || this.contentFormArray.controls[index].value.out_line.trim() == ""
        || this.contentFormArray.controls[index].value.description.trim() == ""
        || this.contentFormArray.controls[index]['controls'].out_line.errors
        || this.contentFormArray.controls[index]['controls'].description.errors
        || this.contentFormArray.controls[index]['controls'].material_id.errors
        || this.contentFormArray.controls[index]['controls'].tagged_interests_attributes.errors) {
        return;
      }

      if (this.paidPlan) {
        this.contentFormArray.controls[index].get('tagged_interests_attributes').setValidators(Validators.required);
        this.durationUnitChange(index);
      }

      if (this.fromModule == 'wipod') {
        const link = this.contentFormArray.controls[0]['controls'].link;
        link.clearValidators();
        link.updateValueAndValidity();
        this.isFileUploaded[index] = true;
      }
    }
    else if (this.step[index] == 2) {
      this.secondStepSubmit[index] = true;

      // if (this.editFlag)
      //   this.onUpdate();
      if(this.bulkDiscountEnabled[index] === true) {
        this.bulkIsEnabled = true
        if (this.contentFormArray.controls[index]['controls'].duration_units_bulk.errors
          || this.contentFormArray.controls[index]['controls'].duration_number_bulk.errors
          || (this.contentFormArray.controls[index]['controls'].duration_number_bulk.value == 0)
          || (this.bulkDiscountEnabled[index] && (((!this.aboveTokenValue[index] || this.aboveTokenValue[index] <= 0) && this.showAboveField[index]) || this.priceFormArray(index).invalid))) {
            return;
          }
      }
      if (this.paidPlan) {
        if (this.contentFormArray.controls[index]['controls'].duration_units.errors
          || this.contentFormArray.controls[index]['controls'].duration_number.errors
          || (this.contentFormArray.controls[index]['controls'].duration_number.value == 0)
          || this.contentFormArray.controls[index]['controls'].tokens.errors
          || (this.activePlan.plan.can_bulk_consume && this.contentFormArray.controls[index]['controls'].no_of_clicks.errors)
          || !this.isFormValid) {
          return;
        }
      }
      if ((!this.editFlag && !this.isTrailerUploaded[index]) || !this.isFileUploaded[index] || this.contentFormArray.controls[index]['controls'].adult_content.errors) {
        return;
      }
    }
    if (this.editFlag && this.userData.user_account_type === 'supplementary') {
      this.step[index] = 3;
      document.querySelector(".modal").scrollTop = 0;
    } else {
      document.querySelector(".modal").scrollTop = 0
      this.step[index] = this.step[index] + 1;
    }
  }

  gotoPrev(index) {
    if (this.currentUser.user.subscription.plan.price !== 0 && this.step[index]==1) {
      this.activeModal.close();
      const modalRef = this.modalService.open(ContentTypeSelectorComponent, {
        size: 'lg',
        centered: true,
        keyboard: false,
        backdrop: 'static'
      });
    } else {
      if (this.editFlag && this.userData.user_account_type === 'supplementary') {
        this.step[index] = 1;
        document.querySelector(".modal").scrollTop = 0;
      } else {
        document.querySelector(".modal").scrollTop = 0;
        this.step[index] = this.step[index] - 1;
      }
    }
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  /**
   * Allow only paste for digits
   *
   * @param {*} event
   * @returns
   * @memberof UploadPublicationComponent
   */
  restrictNumericPaste(event, formIndex?, priceIndex?, controlName?) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");

    if (event.target.id == 'duration_number') {
      let duration_number = (this.contentFormArray.controls[formIndex]['controls'].duration_number.value) ? (this.contentFormArray.controls[formIndex]['controls'].duration_number.value.toString() + filteredText) : filteredText
      this.contentFormArray.controls[formIndex].patchValue({
        duration_number: duration_number.substring(0, 12)
      });
    }
    else if (event.target.id = 'duration_number_bulk') {
      let duration_number_bulk = (this.contentFormArray.controls[formIndex]['controls'].duration_number_bulk.value) ? (this.contentFormArray.controls[formIndex]['controls'].duration_number_bulk.value.toString() + filteredText) : filteredText
      this.contentFormArray.controls[formIndex].patchValue({
        duration_number_bulk: duration_number_bulk.substring(0, 12)
      });
    }
    else if (event.target.id == 'tokens' && !priceIndex) {
      let token = (this.contentFormArray.controls[formIndex]['controls'].tokens.value) ? (this.contentFormArray.controls[formIndex]['controls'].tokens.value.toString() + filteredText) : filteredText

      this.contentFormArray.controls[formIndex].patchValue({
        tokens: token.substring(0, 12)
      });
    }
    else if (event.target.id == 'clicks') {
      let no_of_clicks = (this.contentFormArray.controls[formIndex]['controls'].no_of_clicks.value) ? (this.contentFormArray.controls[formIndex]['controls'].no_of_clicks.value.toString() + filteredText) : filteredText

      this.contentFormArray.controls[formIndex].patchValue({
        no_of_clicks: no_of_clicks.substring(0, 12)
      });
    }
    else if (controlName == 'max_qty') {
      let max_qty = (this.priceFormArray(formIndex).controls[priceIndex]['controls'].max_qty.value) ? (this.priceFormArray(formIndex).controls[priceIndex]['controls'].max_qty.value.toString() + filteredText) : filteredText
      this.priceFormArray(formIndex).controls[priceIndex].patchValue({
        max_qty: max_qty.substring(0, 12)
      });
    }
    else if (controlName == 'tokens') {
      let token = (this.priceFormArray(formIndex).controls[priceIndex]['controls'].tokens.value) ? (this.priceFormArray(formIndex).controls[priceIndex]['controls'].tokens.value.toString() + filteredText) : filteredText
      this.priceFormArray(formIndex).controls[priceIndex].patchValue({
        tokens: token.substring(0, 12)
      });
    }
    else if (controlName == 'aboveToken') {
      let aboveValue = this.aboveTokenValue[formIndex] ? (this.aboveTokenValue[formIndex].toString() + filteredText) : filteredText
      this.aboveTokenValue[formIndex] = aboveValue.substring(0, 12)
    }
    event.preventDefault();
  }


  getMaxValue(event, index) {
    if (event.target.value > 0 && event.target.value < this.aboveValueLimit) {
      this.showAboveField[index] = true;
      this.aboveValue[index] = (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 1)].max_qty > 0) ? (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 1)].max_qty + 1) : (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 2)].max_qty + 1);
    }
    else {
      this.showAboveField[index] = false;
    }
  }

  addMorePrices(index, priceIndex) {
    this.addMorePriceFlag[index][priceIndex].priceFlag = true;
    let price = this.priceFormArray(index).getRawValue();
    let obj;

    if (this.priceFormArray(index).invalid) {
      return;
    }

    //uncomment this in final build and from html line no :320
    // if (this.activePlan.content_price_ranges_limit > (this.priceFormArray(index).controls.length + 1)) {
    if (this.content_price_ranges_limit > (this.priceFormArray(index).controls.length + 1)) {

      obj = this.formBuilder.group({
        min_qty: [(price[priceIndex].max_qty + 1), Validators.compose([Validators.required, Validators.min(price[priceIndex].max_qty + 1), Validators.max(this.aboveValueLimit)])],
        max_qty: [null, Validators.compose([Validators.required, Validators.min(price[priceIndex].max_qty + 2), Validators.max(this.aboveValueLimit)])],
        tokens: [null, Validators.compose([Validators.required, Validators.min(1)])],
        id: ['']
      }, {
        validator: this.maxValueValidator('min_qty', 'max_qty')
      });
      this.priceFormArray(index).push(obj);
      this.priceFormArray(index).controls[priceIndex].disable();
      this.showAboveField[index] = false;
      let addPriceRange =
      {
        priceFlag: false
      }
      this.addMorePriceFlag[index].push(addPriceRange);
      this.aboveTokenValue[index] = '';
    }
    else {
      this.aboveValue[index] = (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 1)].max_qty > 0) ? (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 1)].max_qty + 1) : (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 2)].max_qty + 1);
      if (this.aboveValue[index] > 0)
        this.showAboveField[index] = true;
    }
  }

  removeMorePrices(index, priceIndex) {
    this.priceFormArray(index).removeAt(priceIndex);
    this.addMorePriceFlag[index].pop();
    this.priceFormArray(index).controls[priceIndex - 1].enable();
    this.aboveValue[index] = (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 1)].max_qty > 0) ? (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 1)].max_qty + 1) : (this.priceFormArray(index).getRawValue()[(this.priceFormArray(index).getRawValue().length - 2)].max_qty + 1);
    if (this.aboveValue[index] > 0)
      this.showAboveField[index] = true;
  }

  changebulkDiscount(index) {
    if (!this.bulkDiscountEnabled[index]) {
      let obj = this.formBuilder.group({
        min_qty: [2, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
        max_qty: [null, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
        tokens: [null, Validators.compose([Validators.required, Validators.min(1)])],
        id: ['']
      }, {
        validator: this.maxValueValidator('min_qty', 'max_qty')
      });
      this.priceFormArray(index).push(obj);
    }
    else if (this.bulkDiscountEnabled[index]) {
      this.aboveTokenValue[index] = '';
      this.priceFormArray(index).clear();
      this.showAboveField[index] = false;
    }

    this.bulkDiscountEnabled[index] = !this.bulkDiscountEnabled[index];
  }

  public maxValueValidator(min_qty, max_qty): ValidationErrors | null {
    return (formGroup: FormGroup) => {
      const minQty = formGroup.controls[min_qty];
      const maxQty = formGroup.controls[max_qty];

      // if (minQty.errors && maxQty.errors) {
      //   return;
      // }

      let min_value = minQty.value;
      let max_value = maxQty.value;

      if (min_value == undefined)
        minQty.setErrors({ required: true });

      if (max_value == undefined)
        maxQty.setErrors({ required: true });

      if (min_value && max_value && min_value >= max_value) {
        maxQty.setErrors({ minValue: true });
      }
      else if (min_value && max_value && min_value < max_value && max_value <= this.aboveValueLimit) {
        maxQty.setErrors(null);
      }
      if (min_value && max_value && (min_value == max_value && max_value == this.aboveValueLimit)) {
        maxQty.setErrors(null);
      }
    }

  }

  addMoreContent() {
    if (this.contentFormArray.length < 5) {

      this.contentFormArray.push(this.contentFormBuilder);

      if (this.userData.user_account_type == 'supplementary') {
        this.contentFormArray.controls[this.contentFormArray.length - 1].patchValue({
          adult_content: 'all'
        })
      }

      if (this.paidPlan) {
        let obj = this.formBuilder.group({
          min_qty: [2, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
          max_qty: [null, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
          tokens: [null, Validators.compose([Validators.required, Validators.min(1)])],
          id: ['']
        }, {
          validator: this.maxValueValidator('min_qty', 'max_qty')
        });

        let formRange = [
          {
            priceFlag: false
          }
        ];

        // this.priceFormArray(this.contentFormArray.length - 1).push(obj);
        this.firstStepSubmit.pop();
        this.addMorePriceFlag.push(formRange);
        this.updateTimeMatrixValidation(this.contentFormArray.length - 1);
      }

      this.activePanelIds = [];
      this.activePanelIds.push('panel' + (this.contentFormArray.length));
      this.step[this.contentFormArray.length - 1] = 1;
      this.subscribeContentType(this.contentFormArray.length - 1);
      document.getElementsByClassName('modal')[0].scrollTop = 0;
    }
  }

  deleteContent(index) {
    this.contentFormArray.removeAt(index);
    this.clearForm(index);
    this.step.map((item, index) => {
      this.step[index] = 1
    });
    this.activePanelIds = [];
    this.activePanelIds.push('panel' + (this.contentFormArray.length));
  }

  clearForm(index) {
    // this.imgURL[index] = '';
    this.imgURL.splice(index, 1);
    // this.thumbnail[index] = null;
    this.thumbnail.splice(index, 1);
    // this.isThumbnailUploaded[index] = false;
    this.isThumbnailUploaded.splice(index, 1);
    // this.selectedMaterial[index] = [];
    this.selectedMaterial.splice(index, 1);
    // this.selectedItems[index] = [];
    this.selectedItems.splice(index, 1);


    // this.isTrailerUploaded[index] = false;
    this.isTrailerUploaded.splice(index, 1);
    // this.trailerName[index] = '';
    this.trailerName.splice(index, 1);
    // this.trailerFile[index] = null;
    this.trailerFile.splice(index, 1);

    // this.isAudioBookUploaded[index] = false;
    this.isAudioBookUploaded.splice(index, 1);
    // this.audioFileName[index] = '';
    this.audioFileName.splice(index, 1);
    // this.audioBook[index] = null;
    this.audioBook.splice(index, 1);

    // this.isFileUploaded[index] = false;
    this.isFileUploaded.splice(index, 1);
    // this.fileName[index] = '';
    this.fileName.splice(index, 1);
    // this.file[index] = null;
    this.file.splice(index, 1);

    // this.firstStepSubmit[index] = false;
    this.firstStepSubmit.splice(index, 1);
    // this.secondStepSubmit[index] = false;
    this.secondStepSubmit.splice(index, 1);
  }

  subscribeContentType(index: number) {
    this.contentTypeSubscription = this._contentsService.watchContentType().subscribe((data) => {
      this.contentType = data;
      if (this.contentType) {
        if (this.contentType === 'Publications') {
          this.contentFormArray.controls[index].patchValue({
            content_type: 'document',
            library_type: this.mode
          });
        }
        if (this.contentType === 'Audios') {
          this.contentFormArray.controls[index].patchValue({
            content_type: 'audio',
            library_type: this.mode
          });
        }
        if (this.contentType === 'Videos') {
          this.contentFormArray.controls[index].patchValue({
            content_type: 'video',
            library_type: this.mode
          });
        }
      }
    });
  }
  ngOnChanges() {
  }

  onItemSelect(item: any) {

    if (this.content) {
      const selectInterest = {
        interest_id: item.id
      }
      const index = this.taggedInterestEdit.findIndex(val => val.interest_id === item.id);

      if (index === -1) {
        this.taggedInterestEdit.push(selectInterest)
      }

      this.taggedInterestCopy = this.selectedItems
    }
  }

  onFilterSelectDeselectAll(items: any, value: string) {
    let taggedInterestsArray = [];
    if (value === 'deselect') {
      if (items && items.length) {
        items.forEach((ele) => {
          const obj = {
            id: ele.autoGeneratedId,
            _destroy: true
          };
          taggedInterestsArray.push(obj);
        });
      }
    }
    if (this.selectedItems && this.selectedItems.length) {
      const addedSelectedArray = this.selectedItems.filter((val) => {
        return val.hasOwnProperty('autoGeneratedId');
      });
      addedSelectedArray.forEach((ele) => {
        const obj = {
          id: ele.autoGeneratedId,
          _destroy: true
        };
        taggedInterestsArray.push(obj);
      });
    }
    if (this.deSelectedArray && this.deSelectedArray.length) {
      const deletedArray = this.deSelectedArray.filter((val) => {
        return val.hasOwnProperty('autoGeneratedId');
      });

      deletedArray.forEach((element) => {
        const obj = {
          id: element.autoGeneratedId,
          _destroy: true
        };
        taggedInterestsArray.push(obj);
      });
    }

    if (this.selectedItems && this.selectedItems.length) {
      this.selectedItems.forEach((element) => {
        const obj = {
          interest_id: element.id
        };
        taggedInterestsArray.push(obj);
      });
    }
    this.taggedInterestEdit = JSON.parse(JSON.stringify(taggedInterestsArray));
  }

  OnItemDeSelect(item: any) {
    if (this.deSelectedArray && this.deSelectedArray.length) {
      this.deSelectedArray.push(item);
    }
    if (this.content) {
      if (item.autoGeneratedId) {
        const deSelectInterest = {
          id: item.autoGeneratedId,
          _destroy: true
        };
        const index = this.taggedInterestEdit.findIndex(val => val.id === item.autoGeneratedId);
        if (index === -1) {
          this.taggedInterestEdit.push(deSelectInterest);
        }
        else {
          let tempIndex = this.taggedInterestEdit.findIndex(val => val.interest_id === item.id);
          this.taggedInterestEdit.splice(tempIndex, 1);
        }
      } else {
        const index = this.taggedInterestEdit.findIndex(val => val.interest_id === item.id);
        if (index > -1) {
          this.taggedInterestEdit.splice(index, 1);
        }
      }

      this.taggedInterestCopy = this.selectedItems
    }
  }

  onFilterDeSelectAll(items: any) {
  }

  onSelectAll(items: any, index: any) {
    if (this.content) {
      this.selectedItems[index].forEach(item => {
        if (item.autoGeneratedId) {
          const deSelectInterest = {
            id: item.autoGeneratedId,
            _destroy: true
          };
          this.taggedInterestEdit.push(deSelectInterest);
        }
      });
      //have to change logic here : sunil
      this.selectedItems = [];
      items.forEach(item => {
        const selectInterest = {
          interest_id: item.id
        };
        this.selectedItems.push([item]);
        // const index1 = this.selectedItems.findIndex(val => val.interest_id === item.id)
        const index = this.taggedInterestEdit.findIndex(val => val.interest_id === item.id);
        if (index === -1) {
          this.taggedInterestEdit.push(selectInterest);
        }
      });
      this.taggedInterestCopy = this.selectedItems;
    }
  }

  onDeSelectAll(items: any) {
    if (this.content) {
      this.taggedInterestEdit = [];
      this.dropdownList.forEach(item => {
        if (item.autoGeneratedId) {
          const deSelectInterest = {
            id: item.autoGeneratedId,
            _destroy: true
          }
          const index = this.taggedInterestEdit.findIndex(val => val.id === item.autoGeneratedId);
          if (index === -1) {
            this.taggedInterestEdit.push(deSelectInterest);
          }
          else {
            let tempIndex = this.taggedInterestEdit.findIndex(val => val.interest_id === item.id);
            this.taggedInterestEdit.splice(tempIndex, 1);
          }
        }
        else {
          const index = this.taggedInterestEdit.findIndex(val => val.interest_id === item.id);
          if (index > -1) {
            this.taggedInterestEdit.splice(index, 1);
          }
          // const array = [];
          // if (index > -1) {
          //   array.push(this.taggedInterestEdit[index]);

          // }
          // this.taggedInterestEdit = [...array];
        }
      })
      this.taggedInterestCopy = this.selectedItems
    }
  }

  onMaterialSelect(item: any) {
  }
  OnMaterialDeSelect(item: any) {
  }
  onMaterialSelectAll(items: any) {
  }
  onMaterialDeSelectAll(items: any) {
  }

  filesDropped(files, uploadType, index) {
    const FileObj = files[0].file;
    this.preview({ 0: FileObj }, uploadType, files, index);
  }

  preview(files, uploadType, event = null, index) {
    this.isSvgThumbnailError[index] = false;
    var reader = new FileReader();

    if (files.length === 0)
      return;

    if (uploadType == 'thumbnail') {

      this.thumbnailSizeError[index] = false;

      var fileName = files[0].name.split('.');
      if (!files[0].type.includes('image')) {
        this.isThumbnailError[index] = true;
        this.isThumbnailUploaded[index] = false;
        return;
      }
      this.isThumbnailError[index] = false;

      if (files[0].type !== 'image/png' && files[0].type !== 'image/jpeg') {
        this.isSvgThumbnailError[index] = true;
        return;
      }
      if (files[0].size / 1048576 > 4.999) {
        this.thumbnailSizeError[index] = true;
        return;
      }
      // this.imagePath = files;
      this.thumbnail[index] = files[0];
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {
        const modalRef = this.modalService.open(ImageCropperComponent, { size: 'lg', centered: true });
        modalRef.componentInstance.event = event;
        if (this.contentType.toLowerCase() == 'publications') {
          modalRef.componentInstance.minWidth = 432;
          modalRef.componentInstance.minHeight = 488;
          modalRef.componentInstance.aspectRatio = 432 / 488;
        } else if (this.contentType.toLowerCase() == 'videos') {
          modalRef.componentInstance.minWidth = 508;
          modalRef.componentInstance.minHeight = 304;
          modalRef.componentInstance.aspectRatio = 508 / 304;
        } else if (this.contentType.toLowerCase() == 'audios') {
          modalRef.componentInstance.minWidth = 448;
          modalRef.componentInstance.minHeight = 448;
          modalRef.componentInstance.aspectRatio = 448 / 448;
        }
        modalRef.result.then((result) => {
          this._spinner.hide();
          if (result && result.message === 'success') {
            this.imgURL[index] = result.base64;
            this.thumbnail[index] = result.file;
            this.contentFormArray.controls[index].patchValue({
              thumbnail: this.thumbnail[index],
            });
            this.isThumbnailUploaded[index] = true;
          }
          else {
            this.thumbnail[index] = null;
            event.target.value = '';
          }
        }, (reason) => {
          this.thumbnail[index] = null;
          event.target.value = '';
          this._spinner.hide();
        });
      }
      this.isThumbnailError[index] = false;
    }
    else if (uploadType == 'content') {

      this.fileSizeError[index] = false;
      this.isImageError[index] = false;
      var fileName = files[0].name.split('.');
      this.fileName[index] = files[0].name;
      const extension = fileName[fileName.length - 1];
      if (this.contentType === 'Publications' && this.publicationUploadType.indexOf(extension) === -1) {
        this.isImageError[index] = true;
        return;
      }
      if (this.contentType === 'Audios' && this.audioUploadType.indexOf(extension) === -1) {
        this.isImageError[index] = true;
        return;
      }
      if (this.contentType === 'Videos' && this.videoUploadType.indexOf(extension) === -1) {
        this.isImageError[index] = true;
        return;
      }
      if (this.showFileSizeEror) {
        if (files[0].size / 1048576 > 200.0) {
          this.fileSizeError[index] = true;
          return;
        }
        else {
          this.fileSizeError[index] = false;
        }
      }
      this.isImageError[index] = false;
      // this.imagePath[index] = files;
      this.file[index] = files[0];
      this.contentFormArray.controls[index].patchValue({
        link: this.fileName[index],
      });
      this.isFileUploaded[index] = true;
      this.isImageError[index] = false;
    }
    else if (uploadType == 'audioBook') {
      var fileName = files[0].name.split('.');
      this.audioFileName[index] = files[0].name;
      const extension = fileName[fileName.length - 1];

      if (this.audioUploadType.indexOf(extension) === -1) {
        this.isAudioBookError[index] = true;
        return;
      }

      this.isAudioBookError[index] = false;
      this.audioBook[index] = files[0];
      // this.audioBookPreviewString[index] = reader.result;
      this.isAudioBookUploaded[index] = true;

    } else if (uploadType == 'trailer') {
      if (!this.showTrailerSizeEror) {
        if (files[0].size / 1048576 >= 10.0) { // check for file-size
          this.maxSizeExceded = true
          this.trailerSizeError[index] = true;
          return;
        }
        else {
          this.trailerSizeError[index] = false;
        }
      }
      this.maxSizeExceded = false;
      this.trailerSizeError[index] = false;
      var fileName = files[0].name.split('.');
      this.trailerName[index] = files[0].name;
      const extension = fileName[fileName.length - 1];
      this.trailerFile[index] = files[0];
      if (this.contentType === 'Publications' && this.publicationUploadType.indexOf(extension) === -1) {
        this.isTrailerImageError[index] = true;
        return;
      }
      if (this.contentType === 'Audios' && this.audioUploadType.indexOf(extension) === -1) {
        this.isTrailerImageError[index] = true;
        return;
      }
      if (this.contentType === 'Videos' && this.videoUploadType.indexOf(extension) === -1) {
        this.isTrailerImageError[index] = true;
        return;
      }

      this.isTrailerImageError[index] = false;
      this.trailerPreviewString[index] = reader.result;
      this.isTrailerUploaded[index] = true;
      // reader.readAsDataURL(files[0]);
      // reader.onload = (_event) => {
      //   if (reader.result) {
      //   }
      // }
      this.isTrailerImageError[index] = false;
    }

  }


  filePreview(contentType, index) {
    if (contentType) {
      if (contentType == 'audioBook') {
        this.audioBookPreviewString = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(this.audioBook[index]));
        const modelRef = this.modalService.open(AudioPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'audio-modal' });
        modelRef.componentInstance.url = this.audioBookPreviewString;
        modelRef.componentInstance.localPreview = true;
        modelRef.componentInstance.localPreviewType = 'audio';
      }
      else {
        if (contentType == 'content')
          this.filePreviewString = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(this.file[index]));

        if (contentType == 'trailer')
          this.trailerPreviewString = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(this.trailerFile[index]));

        switch (this.contentType) {
          case "Publications":
            const modelRef = this.modalService.open(PublicationPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'pdf-modal' });
            modelRef.componentInstance.url = (contentType == 'content') ? this.filePreviewString.changingThisBreaksApplicationSecurity : this.trailerPreviewString.changingThisBreaksApplicationSecurity;
            modelRef.result.then(
              (response) => {
                if (this.filePreviewString)
                  window.URL.revokeObjectURL(this.filePreviewString);
                if (this.trailerPreviewString)
                  window.URL.revokeObjectURL(this.trailerPreviewString);
              }, (error) => {
                if (this.filePreviewString)
                  window.URL.revokeObjectURL(this.filePreviewString);
                if (this.trailerPreviewString)
                  window.URL.revokeObjectURL(this.trailerPreviewString);
              })
            break;

          case "Videos":
            const modelRefTransfer = this.modalService.open(VideoPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'video-modal', keyboard: false, backdrop: 'static' });
            modelRefTransfer.componentInstance.url = (contentType == 'content') ? this.filePreviewString : this.trailerPreviewString;
            modelRefTransfer.componentInstance.localPreview = true;
            modelRefTransfer.componentInstance.localPreviewType = 'video';
            modelRefTransfer.result.then(
              (response) => {
                if (this.filePreviewString)
                  window.URL.revokeObjectURL(this.filePreviewString);
                if (this.trailerPreviewString)
                  window.URL.revokeObjectURL(this.trailerPreviewString);
              }, (error) => {
                if (this.filePreviewString)
                  window.URL.revokeObjectURL(this.filePreviewString);
                if (this.trailerPreviewString)
                  window.URL.revokeObjectURL(this.trailerPreviewString);
              })
            break;

          case "Audios":
            const modelRefAudio = this.modalService.open(AudioPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'audio-modal' });
            modelRefAudio.componentInstance.url = (contentType == 'content') ? this.filePreviewString : this.trailerPreviewString;
            modelRefAudio.componentInstance.localPreview = true;
            modelRefAudio.componentInstance.localPreviewType = 'audio';
            modelRefAudio.result.then(
              (response) => {
                if (this.filePreviewString)
                  window.URL.revokeObjectURL(this.filePreviewString);
                if (this.trailerPreviewString)
                  window.URL.revokeObjectURL(this.trailerPreviewString);
              }, (error) => {
                if (this.filePreviewString)
                  window.URL.revokeObjectURL(this.filePreviewString);
                if (this.trailerPreviewString)
                  window.URL.revokeObjectURL(this.trailerPreviewString);
              })
            break;
          default:
            break;
        }
      }
      //   else {
      //     switch (this.contentType) {
      //       case "Publications":
      //         const modelRef = this.modalService.open(PublicationPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'pdf-modal' });
      //         modelRef.componentInstance.url = (contentType == 'content') ? this.filePreviewString : this.trailerPreviewString;
      //         break;
      //       case "Videos":
      //         const modelRefTransfer = this.modalService.open(VideoPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'video-modal' });
      //         modelRefTransfer.componentInstance.url = (contentType == 'content') ? this.filePreviewString : this.trailerPreviewString;
      //         break;
      //       case "Audios":
      //         const modelRefAudio = this.modalService.open(AudioPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'audio-modal' });
      //         modelRefAudio.componentInstance.url = (contentType == 'content') ? this.filePreviewString : this.trailerPreviewString;
      //         break;
      //       default: break;
      //     }
      //   }
      // }
    }
  }
  onSubmit() {
    this.submitted = true;

    if (this.contentFormArray.invalid) {
      return;
    }
    else {

      let data = [];

      for (let index = 0; index < this.contentFormArray.controls.length; index++) {

        const taggedInterestsAttributes = [];

        this.selectedItems[index].forEach(element => {
          taggedInterestsAttributes.push({
            interest_id: element.id
          })
        });

        let totalSize = 0;

        if (this.fromModule != 'wipod') {
          totalSize = this.file[index].size;
        }

        const number = this.contentFormArray.controls[index].value.duration_number;
        const number_bulk = this.contentFormArray.controls[index].value.duration_number_bulk;
        const units = this.contentFormArray.controls[index].value.duration_units;
        const units_bulk = this.contentFormArray.controls[index].value.duration_units_bulk;

        if (this.audioBook[index]) {
          totalSize += this.audioBook[index].size;
        }
        if (this.trailerFile[index]) {
          totalSize += this.trailerFile[index].size;
        }

        const obj = {
          out_line: this.contentFormArray.controls[index].value.out_line,
          description: this.contentFormArray.controls[index].value.description,
          library_type: this.contentFormArray.controls[index].value.library_type,
          is_deleted: false,
          link: this.fileLink[index],
          content_type: this.contentFormArray.controls[index].value.content_type,
          tagged_interests_attributes: taggedInterestsAttributes,
          material_id: this.selectedMaterial[index][0]['id'],
          duration_number: this.contentFormArray.controls[index].value.duration_number,
          duration_number_bulk: this.contentFormArray.controls[index].value.duration_number_bulk,
          duration_units: this.contentFormArray.controls[index].value.duration_units,
          duration_units_bulk: this.contentFormArray.controls[index].value.duration_units_bulk,
          file_size: parseInt((totalSize / 1024).toFixed(0)),
          is_downloadable: this.contentFormArray.controls[index].value.is_downloadable,
          thumbnail: this.thumbnail[index],
          adult_content: this.contentFormArray.controls[index].value.adult_content == 'all' ? false : true,
          tokens: this.contentFormArray.controls[index].value.tokens || 0,
          duration: number + ' ' + units,
          duration_bulk: number_bulk + ' ' + units_bulk,
          // file_name: this.file
        }

        if (this.audioBook[index]) {
          obj['audio_book'] = this.audioFileLink[index];
          // data['audio_book_file'] = this.audioBook;
        }
        if (this.trailerFile[index]) {
          obj['preview_link'] = this.trailerFileLink[index];
          // data['preview_link_file'] = this.trailerFile
        }
        if (this.priceFormArray(index).getRawValue() && this.bulkDiscountEnabled[index]) {

          let getRangeValues = this.priceFormArray(index).getRawValue();
          let abovePriceRange = {
            min_qty: this.aboveValue[index],
            max_qty: this.aboveValueLimit,
            tokens: this.aboveTokenValue[index]
          }
          getRangeValues.push(abovePriceRange);

          obj['content_prices_attributes'] = getRangeValues;
        }
        data.push(obj);
      }
      // this.showProgress = true;
      this._contentsService.createContent(data).subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            // console.log('Request has been made!');
            break;
          case HttpEventType.ResponseHeader:
            // console.log('Response header has been received!');
            break;
          case HttpEventType.UploadProgress:
            // this.progress = Math.round(event.loaded / event.total * 100);
            // console.log(`Uploaded! ${this.progress}%`);
            break;
          case HttpEventType.Response:
            this.showProgress = false;
            let response = event.body;
            if (response.success) {
              this.closeDialog(true);
              if (this.contentType == 'Publications' && this.mode == 'private') {
                this.modalService.open(PublicationUploadedComponent, { centered: true });
                return;
              }
              if (this.contentType == 'Videos' && this.mode == 'private') {
                this.modalService.open(VideoUploadedComponent, { centered: true });
                return;
              }
              if (this.contentType == 'Audios' && this.mode == 'private') {
                this.modalService.open(AudioUploadedComponent, { centered: true });
                return;
              }
              if (this.contentType == 'Publications' && this.mode == 'public') {
                const modalRef = this.modalService.open(PublicationPublishedComponent, { centered: true });
                if (response.message == "Awaiting for approval") {
                  modalRef.componentInstance.message = "Your material will be published to your public library once it is approved by your parent. You can check the status into your private library.";
                  modalRef.componentInstance.title = "Success";
                }
                return;
              }
              if (this.contentType == 'Videos' && this.mode == 'public') {
                const modalRef = this.modalService.open(VideoPublishedComponent, { centered: true });
                if (response.message == "Awaiting for approval") {
                  modalRef.componentInstance.message = "Your material will be published to your public library once it is approved by your parent. You can check the status into your private library.";
                  modalRef.componentInstance.title = "Success";
                }
                return;
              }
              if (this.contentType == 'Audios' && this.mode == 'public') {
                const modalRef = this.modalService.open(AudioPublishedComponent, { centered: true });
                if (response.message == "Awaiting for approval") {
                  modalRef.componentInstance.message = "Your material will be published to your public library once it is approved by your parent. You can check the status into your private library.";
                  modalRef.componentInstance.title = "Success";
                }
                return;
              }
            }
            else {
              let subscriptionFlag = false;
              if (response.status === 426) {
                this.closeDialog(true);
                const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
                modalRef.componentInstance.spaceError = this.str;
                modalRef.componentInstance.contentType = this.contentType;
                return;
              }
              else if (response.errors && response.errors instanceof Array && response.errors.length > 0) {
                response.errors.forEach(element => {
                  if (element.detail == "You need to upgrade your subscription plan") {
                    subscriptionFlag = true;
                  }
                });
              }

              if (subscriptionFlag) {
                const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
                modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CHOOSE_THE_SUBSCRIPTION_PLAN;
              }
              else {
                this.isError = true;
                if (this.contentType == 'Publications' && this.mode == 'private') {
                  const modalRef = this.modalService.open(PublicationNotUploadedComponent, { centered: true });
                  if (response.errors && response.errors[0]) {
                    modalRef.componentInstance.message = response.errors[0].detail;
                  }
                  return;
                }
                if (this.contentType == 'Videos' && this.mode == 'private') {
                  const modalRef = this.modalService.open(VideoNotUploadedComponent, { centered: true });
                  if (response.errors && response.errors[0]) {
                    modalRef.componentInstance.message = response.errors[0].detail;
                  }
                  return;
                }
                if (this.contentType == 'Audios' && this.mode == 'private') {
                  const modalRef = this.modalService.open(AudioNotUploadedComponent, { centered: true });
                  if (response.errors && response.errors[0]) {
                    modalRef.componentInstance.message = response.errors[0].detail;
                  }
                  return;
                }
                if (this.contentType == 'Publications' && this.mode == 'public') {
                  const modalRef = this.modalService.open(PublicationNotPublishedComponent, { centered: true });
                  if (response.errors && response.errors[0]) {
                    modalRef.componentInstance.message = response.errors[0].detail;
                  }
                  return;
                }
                if (this.contentType == 'Videos' && this.mode == 'public') {
                  const modalRef = this.modalService.open(VideoNotPublishedComponent, { centered: true });
                  if (response.errors && response.errors[0]) {
                    modalRef.componentInstance.message = response.errors[0].detail;
                  }
                  return;
                }
                if (this.contentType == 'Audios' && this.mode == 'public') {
                  const modalRef = this.modalService.open(AudioNotPublishedComponent, { centered: true });
                  if (response.errors && response.errors[0]) {
                    modalRef.componentInstance.message = response.errors[0].detail;
                  }
                  return;
                }
              }

            }
            break;
        }
      });
      return;
    }
  }

  removeFile(contentType, index) {
    if (contentType == 'thumbnail') {
      this.imgURL[index] = '';
      this.thumbnail[index] = null;
      this.isThumbnailUploaded[index] = false;
      this.contentFormArray.controls[index].patchValue({
        thumbnail: '',
      });
    }
    else if (contentType == 'content') {
      this.isFileUploaded[index] = false;
      this.fileName[index] = '';
      this.file[index] = null;
      this.contentFormArray.controls[index].patchValue({
        link: '',
      });
    }
    else if (contentType == 'audioBook') {
      this.isAudioBookUploaded[index] = false;
      this.audioFileName[index] = '';
      this.audioBook[index] = null;
    }
    else if (contentType == 'trailer') {
      this.isTrailerUploaded[index] = false;
      this.trailerName[index] = '';
      this.trailerFile[index] = null;
    }
  }

  checkSpace() {
    let totalSize = 0;

    for (let index = 0; index < this.contentFormArray.controls.length; index++) {
      if (this.file[index]) {
        totalSize += this.file[index].size;
      }
      if (this.audioBook[index]) {
        totalSize += this.audioBook[index].size;
      }
      if (this.trailerFile[index]) {
        totalSize += this.trailerFile[index].size;
      }
      if (this.activePlan && this.activePlan.remaining_space && totalSize) {
        const allowed_size = this.activePlan.remaining_space / 1024;
        const totalCalcSize = totalSize / 1048576;
        if (totalCalcSize > allowed_size) {
          this.submitted = false;
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.spaceError = this.str;
          modalRef.componentInstance.contentType = this.contentType;
          return true;
        }
      }
    }
  }

  async onPrivate() {


    this.mode = 'private';
    this.submitted = true;

    let queueData = [];

    for (let index = 0; index < this.contentFormArray.controls.length; index++) {

      this.contentFormArray.controls[index].patchValue({
        library_type: "private",
        out_line: this.contentFormArray.controls[index].value.out_line.trim(),
        description: this.contentFormArray.controls[index].value.description.trim(),
        thumbnail: this.thumbnail[index]
      });

      if((this.bulkIsEnabled && (this.contentFormArray.controls[index].value['out_line'] == "" ||
          this.contentFormArray.controls[index].value['description'] == "" ||
          this.contentFormArray.controls[index].value['duration_number'] == '0' ||
          this.contentFormArray.controls[index].value['duration_number_bulk'] == '0' ||
          this.contentFormArray.controls[index]['controls'].out_line.invalid ||
          this.contentFormArray.controls[index]['controls'].description.invalid ||
          this.contentFormArray.controls[index]['controls'].tagged_interests_attributes.invalid ||
          this.contentFormArray.controls[index]['controls'].duration_number.invalid ||
          this.contentFormArray.controls[index]['controls'].duration_number_bulk.invalid ||
          this.contentFormArray.controls[index]['controls'].tokens.invalid ||
          this.contentFormArray.controls[index]['controls'].duration_units.invalid ||
          this.contentFormArray.controls[index]['controls'].duration_units_bulk.invalid ||
          this.contentFormArray.controls[index]['controls'].material_id.invalid ||
          this.contentFormArray.controls[index]['controls'].adult_content.invalid))
          ||
          (!this.bulkIsEnabled && (this.contentFormArray.controls[index].value['out_line'] == "" ||
          this.contentFormArray.controls[index].value['description'] == "" ||
          this.contentFormArray.controls[index].value['duration_number'] == '0' ||
          this.contentFormArray.controls[index].value['duration_number_bulk'] == '0' ||
          this.contentFormArray.controls[index]['controls'].out_line.invalid ||
          this.contentFormArray.controls[index]['controls'].description.invalid ||
          this.contentFormArray.controls[index]['controls'].tagged_interests_attributes.invalid ||
          this.contentFormArray.controls[index]['controls'].duration_number.invalid ||
          this.contentFormArray.controls[index]['controls'].tokens.invalid ||
          this.contentFormArray.controls[index]['controls'].duration_units.invalid ||
          this.contentFormArray.controls[index]['controls'].material_id.invalid ||
          this.contentFormArray.controls[index]['controls'].adult_content.invalid))) {
          this.onSubmit();
      } else {

        queueData[index] = {
          audioBook: this.audioBook[index] ? this.audioBook[index] : '',
          content: this.file[index] ? this.file[index] : '',
          formData: this.contentFormArray.controls[index].value,
          trailer: this.trailerFile[index] ? this.trailerFile[index] : '',
        }

        if (this.priceFormArray(index).getRawValue() && this.bulkDiscountEnabled[index]) {

          let getRangeValues = this.priceFormArray(index).getRawValue();
          if (this.showAboveField[index]) {
            let abovePriceRange = {
              min_qty: this.aboveValue[index],
              max_qty: this.aboveValueLimit,
              tokens: this.aboveTokenValue[index]
            }
            getRangeValues.push(abovePriceRange);
          }
          queueData[index].formData.content_prices_attributes = getRangeValues;
        }
        queueData[index].formData['max_value_for_price_range'] = this.aboveValueLimit;
        queueData[index].formData['price_range_limit'] = this.content_price_ranges_limit;
        // if (this.file[index] && this.thumbnail[index] && this.isAudioBookUploaded[index]) {
        //   this.showProgress = true;
        //   await this.getPreAssignedURL('audioBook', index);
        // } else if (this.file[index] && this.thumbnail[index] && this.isTrailerUploaded[index]) {
        //   this.showProgress = true;
        //   await this.getPreAssignedURL('trailer', index);
        // } else if (this.file[index] && this.thumbnail[index]) {
        //   this.showProgress = true;
        //   await this.getPreAssignedURL('content', index);
        // }
        // else {
        //   this.isError = true;
        // }
        // this.currentUploadIndex = index + 1;
      }
    }
    if (this.fromModule == 'wipod') {
      queueData[0].formData.library_type = 'wipod';
      queueData[0].formData['template_id'] = this.selectedTemplate.id;
      queueData[0].formData['publication_text'] = this.publication_text;
    }
    // update storage space data before save
    const size_error = this.checkStorage(queueData);
  }

  checkStorage(queueData) {
    this._plansService.getActivePlan().subscribe((response: any) => {
      if (response.success) {
        this.activePlan = response.data.subscription[0];

        if (this.activePlan && this.activePlan.plan && this.activePlan.plan.price > 0 && this.paidPlan) {
          this.paidPlan = true;

          this.aboveValueLimit = (this.content && this.content.max_value_for_price_range > 0) ? this.content.max_value_for_price_range : this.activePlan.max_value_for_above_content_price;
          this.content_price_ranges_limit = (this.content && this.content.price_range_limit > 0) ? this.content.price_range_limit : this.activePlan.content_price_ranges_limit;

          // this.aboveValueLimit = this.activePlan.max_value_for_above_content_price;
          // this.content_price_ranges_limit = this.activePlan.content_price_ranges_limit;

          // this.updateTimeMatrixValidation(0);
          this.showTrailerSizeEror = false;
          this.showFileSizeEror = false;
        }
        else if (this.activePlan && this.activePlan.plan && this.activePlan.plan.price > 0 && !this.paidPlan) {
          this.showFileSizeEror = false;
          this.showTrailerSizeEror = false;
        }
        else {
          this.paidPlan = false;
          this.showFileSizeEror = true;
          this.showTrailerSizeEror = true;
          // this.contentFormArray.controls[0].patchValue({
          //   tokens: 0
          // })
        }
      }
      setTimeout(() => {
        const res = this.checkSpace();
        if (!res) {
          this._authService.setUploadingQueue(queueData);
          this.openUserConfirmModal();
        }
      }, 0);
    })
  }

  openUserConfirmModal() {
    this.closeDialog(true);
    const modalRef = this.modalService.open(UserConfirmedComponent, { centered: true });
    modalRef.componentInstance.message = 'Uploading will start soon.';
    modalRef.result.then(response => {
      if (this.fromModule == 'wipod') {
        this._router.navigate(['/wipod']);
      }
    })
  }

  onUpdate() {

    const link = this.contentFormArray.controls[0]['controls'].link;
    link.clearValidators();
    link.updateValueAndValidity();

    if (this.step[0] != 3)
      return;

    if (this.taggedInterestCopy.length > 0) {
      const taggedEle1 = this.contentFormArray.controls[0]['controls'].tagged_interests_attributes;
      taggedEle1.clearValidators();
      taggedEle1.updateValueAndValidity();
    }

    if (this.contentFormArray.invalid) {
      return;
    }

    this.submitted = true;

    let obj = {
      "content": {
        "tokens": this.contentFormArray.controls[0]['controls'].tokens.value || 0,
        "duration_number": this.contentFormArray.controls[0]['controls'].duration_number.value,
        "duration_number_bulk": this.contentFormArray.controls[0]['controls'].duration_number_bulk.value,
        "duration_units": this.contentFormArray.controls[0]['controls'].duration_units.value,
        "duration_units_bulk": this.contentFormArray.controls[0]['controls'].duration_units_bulk.value,
        "is_downloadable": false,
        "duration": `${this.contentFormArray.controls[0]['controls'].duration_number.value} ${this.contentFormArray.controls[0]['controls'].duration_units.value}`,
        "duration_bulk": `${this.contentFormArray.controls[0]['controls'].duration_number_bulk.value} ${this.contentFormArray.controls[0]['controls'].duration_units_bulk.value}`,
        "out_line": this.contentFormArray.controls[0]['controls'].out_line.value.trim(),
        "description": this.contentFormArray.controls[0]['controls'].description.value.trim(),
        "adult_content": this.contentFormArray.controls[0]['controls'].adult_content.value === 'all' ? false : true,
        "tagged_interests_attributes": [...this.taggedInterestEdit],
        "material_id": this.selectedMaterial[0][0]['id']

      }
    }
    if (this.thumbnail[0]) {
      obj['content']['thumbnail'] = this.thumbnail[0];
    }

    if (this.contentFormArray.controls[0]['controls'].no_of_clicks.value >= 0) {
      obj['no_of_clicks'] = this.contentFormArray.controls[0]['controls'].no_of_clicks.value;
    }

    if (this.priceFormArray(0).getRawValue() && this.bulkDiscountEnabled[0]) {

      let getRangeValues = this.priceFormArray(0).getRawValue();
      if (this.showAboveField[0]) {
        let abovePriceRange = {
          min_qty: this.aboveValue[0],
          max_qty: this.aboveValueLimit,
          tokens: this.aboveTokenValue[0]
        }
        getRangeValues.push(abovePriceRange);
      }

      if (getRangeValues.length >= this.content.content_prices.length) {

        getRangeValues.map((item, index) => {
          if (this.content.content_prices[index]) {
            item.id = this.content.content_prices[index].id
          }
          else {
            delete item.id;
          }
        })
      }
      else if (getRangeValues.length < this.content.content_prices.length) {
        this.content.content_prices.map((item, index) => {
          if (getRangeValues[index]) {
            getRangeValues[index].id = item.id
          }
          else {
            let obj = {
              id: item.id,
              _destroy: true
            }
            getRangeValues.push(obj);
          }
        })
      }

      obj['content']['content_prices_attributes'] = getRangeValues;
      // obj['content']['max_value_for_price_range'] = this.aboveValueLimit;
      // obj['content']['price_range_limit'] = this.content_price_ranges_limit;
    }
    else if (!this.bulkDiscountEnabled[0] && this.content.content_prices.length > 0) {
      let getRangeValues = [];
      this.content.content_prices.map((item) => {
        let obj = {
          id: item.id,
          _destroy: true
        }
        getRangeValues.push(obj);
      });
      obj['content']['content_prices_attributes'] = getRangeValues;
    }

    let updateSubscriber;
    if (this.for == 'editWIPOD') {
      obj['id'] = this.content.id;
      // obj['content']['template_id'] = this.selectedTemplate.template_id;
      obj['content']['content_texts'] = [];
      this.publication_text.filter((element, index) => {
        let data = {
          id: element.id,
          user_id: element.user_id,
          index_position: element.index_position,
          publication_text: element.publication_text,
        }
        obj['content']['content_texts'].push(data);
      });
      updateSubscriber = this._contentsService.updateWIPOD(obj)
    }
    else {
      updateSubscriber = this._contentsService.updateContent(obj, this.content.id)
    }
    // window.scrollTo(0, document.body.scrollHeight);
    this._spinner.show();
    updateSubscriber.subscribe((response: any) => {
      if (response.success) {
        this._spinner.hide();
        if (this.for == 'editWIPOD') {
          this.activeModal.close();
        }
        else {
          this.closeDialog(true);
        }
        if (this.contentType == 'Publications' || this.contentType == 'publications') {
          const modelRef = this.modalService.open(PublicationUploadedComponent, { centered: true });
          modelRef.componentInstance.type = 'edit';
        }
        if (this.contentType == 'Videos' || this.contentType == 'videos') {
          const modelRef = this.modalService.open(VideoUploadedComponent, { centered: true });
          modelRef.componentInstance.type = 'edit';
        }
        if (this.contentType == 'Audios' || this.contentType == 'audios') {
          const modelRef = this.modalService.open(AudioUploadedComponent, { centered: true });
          modelRef.componentInstance.type = 'edit';
        }
      }
      else {
        this._spinner.hide();
        this.closeDialog(true);
        if (this.contentType == 'Publications' || this.contentType == 'publications') {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
        }
      }

    }, (error: any) => {
      this._spinner.hide();
      this.closeDialog(true);
      if (this.contentType == 'Publications' || this.contentType == 'publications') {
        const modelRef = this.modalService.open(PublicationNotUploadedComponent, { centered: true });
        modelRef.componentInstance.type = 'edit';
      }
      if (this.contentType == 'Videos' || this.contentType == 'videos') {
        const modelRef = this.modalService.open(VideoNotUploadedComponent, { centered: true });
        modelRef.componentInstance.type = 'edit';
      }
      if (this.contentType == 'Audios' || this.contentType == 'audios') {
        const modelRef = this.modalService.open(AudioNotUploadedComponent, { centered: true });
        modelRef.componentInstance.type = 'edit';
      }
    });
  }

  closeDialog(status?, from?) {
    if (status) {
      this.activeModal.close('success');
      return;
    }
    else {
      if (confirm('Are you sure you want to cancel the updated information?')) {
        if (this.for == 'editWIPOD') {
          this.activeModal.close('failure');
        }
        else if (from == 'close') {
          this.activeModal.close('success');
        }
        else
          this.activeModal.close();
      }
      return;
    }
  }

  ngOnDestroy() {
    if (this.contentTypeSubscription) {
      this.contentTypeSubscription.unsubscribe();
    }
    document.body.classList.remove("upload-modal");
  }

  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
    // event.target.style.height = "1px";
    // event.target.style.height = (event.target.scrollHeight)+"px";
  }

  getActivePlan() {
    this._plansService.getActivePlan().subscribe((response: any) => {
      if (response.success) {
        this.activePlan = response.data.subscription[0];

        if (this.activePlan && this.activePlan.plan && this.activePlan.plan.price > 0 && this.paidPlan) {
          this.paidPlan = true;

          this.aboveValueLimit = (this.content && this.content.max_value_for_price_range > 0) ? this.content.max_value_for_price_range : this.activePlan.max_value_for_above_content_price;
          this.content_price_ranges_limit = (this.content && this.content.price_range_limit > 0) ? this.content.price_range_limit : this.activePlan.content_price_ranges_limit;

          // this.aboveValueLimit = this.activePlan.max_value_for_above_content_price;
          // this.content_price_ranges_limit = this.activePlan.content_price_ranges_limit;

          this.updateTimeMatrixValidation(0);
          this.showTrailerSizeEror = false;
          this.showFileSizeEror = false;
        }
        else if (this.activePlan && this.activePlan.plan && this.activePlan.plan.price > 0 && !this.paidPlan) {
          this.showFileSizeEror = false;
          this.showTrailerSizeEror = false;
        } else if (this.editFlag && this.userData && this.userData.last_plan && this.userData.last_plan.plan.price > 0 && this.content && this.content.tokens > 0) {
          this.paidPlan = true;
        }
        else {
          this.paidPlan = false;
          // this.showFileSizeEror = true;
          // this.showTrailerSizeEror = true;
          this.contentFormArray.controls[0].patchValue({
            tokens: 0
          })
        }
      }
    })
  }

  updateTimeMatrixValidation(index) {
    if (!this.editFlag) {
      this.contentFormArray.controls[index].patchValue({
        tokens: ''
      })
    }
    if (this.activePlan.plan && this.activePlan.plan.can_bulk_consume) {
      this.contentFormArray.controls[index]['controls'].no_of_clicks.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN), Validators.min(0)]));
      this.contentFormArray.controls[index]['controls'].no_of_clicks.updateValueAndValidity();
    }
    if (this.content && this.content.content_prices.length > 0) {

      let flag;
      if (this.showAboveField[index])
        flag = 1;
      else
        flag = 0;

      for (let indx = 0; indx < this.content.content_prices.length - flag; indx++) {
        this.priceFormArray(index).controls[indx]['controls']['min_qty'].setValidators(Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)]));
        this.priceFormArray(index).controls[indx]['controls']['min_qty'].updateValueAndValidity();

        this.priceFormArray(index).controls[indx]['controls']['max_qty'].setValidators(Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)]));
        this.priceFormArray(index).controls[indx]['controls']['max_qty'].updateValueAndValidity();

        if (this.priceFormArray(index).controls[indx]['controls']['min_qty'].errors && this.priceFormArray(index).controls[indx]['controls']['min_qty'].errors.max) {
          this.priceFormArray(index).controls[indx]['controls']['min_qty'].setErrors(null);
        }
      }
    }
    // max_qty: [null, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
    this.contentFormArray.controls[index]['controls'].duration_units.setValidators(Validators.required);
    this.contentFormArray.controls[index]['controls'].duration_units.updateValueAndValidity();
    this.contentFormArray.controls[index]['controls'].duration_units_bulk.setValidators(Validators.required);
    this.contentFormArray.controls[index]['controls'].duration_units_bulk.updateValueAndValidity();
    this.contentFormArray.controls[index]['controls'].duration_number.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN)]));
    this.contentFormArray.controls[index]['controls'].duration_number.updateValueAndValidity();
    this.contentFormArray.controls[index]['controls'].duration_number_bulk.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN)]));
    this.contentFormArray.controls[index]['controls'].duration_number_bulk.updateValueAndValidity();
    this.contentFormArray.controls[index]['controls'].tokens.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN), Validators.min(1)]));
    this.contentFormArray.controls[index]['controls'].tokens.updateValueAndValidity();
  }

  durationUnitChange(index) {
    if (this.contentFormArray.controls[index]['controls'].duration_units.value === 'weeks' || this.contentFormArray.controls[index]['controls'].duration_units_bulk.value === 'weeks') {
      this.contentFormArray.controls[index]['controls'].duration_number.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.max(4)]));
      this.contentFormArray.controls[index]['controls'].duration_number_bulk.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.max(4)]));
    }
    if (this.contentFormArray.controls[index]['controls'].duration_units.value === 'days' || this.contentFormArray.controls[index]['controls'].duration_units_bulk.value === 'weeks') {
      this.contentFormArray.controls[index]['controls'].duration_number.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.max(7)]));
      this.contentFormArray.controls[index]['controls'].duration_number_bulk.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.max(7)]));
    }
    if (this.contentFormArray.controls[index]['controls'].duration_units.value === 'months' || this.contentFormArray.controls[index]['controls'].duration_units_bulk.value === 'weeks') {
      this.contentFormArray.controls[index]['controls'].duration_number.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.max(12)]));
      this.contentFormArray.controls[index]['controls'].duration_number_bulk.setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.max(12)]));
    }
    this.contentFormArray.controls[index]['controls'].duration_number.updateValueAndValidity();
    this.contentFormArray.controls[index]['controls'].duration_number_bulk.updateValueAndValidity();
  }

  trailerValidation() {
    if (!this.contentFormArray.controls.length) {
      return false;
    }
    for (let i = 0; i < this.contentFormArray.controls.length; i++) {
      if (!this.isTrailerUploaded[i]) {
        return false;
      }
    }
    return true;
  }

  aboveFieldValidation() {
    if (!this.contentFormArray.controls.length) {
      return false;
    }
    for (let i = 0; i < this.contentFormArray.controls.length; i++) {
      if (this.showAboveField[i] && (this.aboveTokenValue[i] == undefined || this.aboveTokenValue[i] === '' || this.aboveTokenValue[i] <= 0)) {
        return false;
      }
    }
    return true;
  }

  isPriceValid(range, index) {
    if (index == 0 && range.get('min_qty').value > this.aboveValueLimit - 1) {
      this.isFormValid = false;
      return false;
    }
    else {
      this.isFormValid = true;
      return true;
    }
  }
}

